/**
 * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
 * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
 *
 * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
 */

/**
 * Transform the timer definition returned by the backend into timersStore records.
 * @param {Object?} initialTimersData
 * @returns {Object[]}
 */
export function buildInitialTimersStoreData(initialTimersData) {
    const timersData = [];

    if (!initialTimersData) {
        return timersData;
    }

    if (!initialTimersData.extra) {
        initialTimersData = Object.assign({}, initialTimersData, {
            extra: { maxTime: 0, maxTimeRemaining: 0 }
        });
    }

    ['test', 'extra'].forEach(levelName => {
        if (levelName in initialTimersData && initialTimersData[levelName]) {
            const initialTimer = initialTimersData[levelName];
            timersData.push({
                level: levelName,
                timerValue: {
                    timeLeft: initialTimer.maxTimeRemaining,
                    timeAssigned: initialTimer.maxTime
                }
            });
        }
    });

    ['testParts', 'sections', 'items'].forEach(levelName => {
        if (levelName in initialTimersData && initialTimersData[levelName]) {
            initialTimersData[levelName].forEach(initialTimer => {
                timersData.push({
                    level: levelName.replace(/s$/, ''),
                    id: initialTimer.id,
                    timerValue: {
                        minTime: initialTimer.minTime,
                        maxTime: initialTimer.maxTime,
                        timeLeft: initialTimer.maxTimeRemaining,
                        timeAssigned: initialTimer.maxTime
                    }
                });
            });
        }
    });

    return timersData;
}
